<template>
  <btn
    :href="url"
    as="a"
    kind="ebay"
    target="_blank"
    class="card-ebay-link"
  >
    <span class="container">
      <span>Buy it now on</span>
      <img alt="eBay" :src="EbayLogo" />
    </span>
  </btn>
</template>

<script>
import Btn from './Btn';
import EbayLogo from '../images/ebay-logo.svg?inline';
import { toEbayUrl } from '../utils/format.util';

export default {
  components: {
    Btn,
  },

  props: {
    query: String,
    isPublic: Boolean,
  },

  data() {
    return {
      EbayLogo,
    };
  },

  computed: {
    url() {
      return toEbayUrl(`/sch/i.html?_nkw=${encodeURIComponent(this.query)}`, this.isPublic);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.card-ebay-link {
  width: 100%;
  height: 46px;
}

.container {
  display: inline-flex;
  align-items: center;
  font-size: 18px;
}

img {
  margin-left: 5px;
  margin-top: 2px;
  width: auto;
  height: 24px;
}
</style>
